var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDNavLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166626 19.0003L10.5833 27.3337V21.0837H29.3333V16.917H10.5833V10.667L0.166626 19.0003Z",
    fill: "#33277B",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0856 0.248118C20.6221 0.241288 18.1818 0.723349 15.9059 1.66638C13.6301 2.6094 11.5639 3.99465 9.82727 5.74187L12.7731 8.6877C15.5273 5.93354 19.1898 4.41478 23.0856 4.41478C26.9814 4.41478 30.6439 5.93354 33.3981 8.6877C36.1523 11.4419 37.671 15.1044 37.671 19.0002C37.671 22.896 36.1523 26.5585 33.3981 29.3127C30.6439 32.0669 26.9814 33.5856 23.0856 33.5856C19.1898 33.5856 15.5273 32.0669 12.7731 29.3127L9.82727 32.2585C13.3669 35.8002 18.0752 37.7523 23.0856 37.7523C28.096 37.7523 32.8043 35.8002 36.3439 32.2585C39.8856 28.719 41.8377 24.0106 41.8377 19.0002C41.8377 13.9898 39.8856 9.28145 36.3439 5.74187C34.6073 3.99465 32.5411 2.6094 30.2653 1.66638C27.9894 0.723349 25.5491 0.241288 23.0856 0.248118Z",
    fill: "#33277B",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDNavLogout);
export default __webpack_public_path__ + "static/media/d-nav-logout.76d710ce94f547eddcd5847bbe5a3605.svg";
export { ForwardRef as ReactComponent };